export default __webpack_public_path__ + "static/media/htb-alex.53dcb9c4.jpg";